module.exports = __webpack_public_path__ + "static/media/pan.0d5c9f24.svg";